import React from 'react'
import { styled } from '@mui/material/styles'
import dynamic from 'next/dynamic'
import { Container, Typography } from '@mui/material/'
import { Author } from '@components/organisms/Article/Author'
import { Date } from '@components/organisms/Article/Date'
import { Tags } from '@components/organisms/Article/Tags'
import { SkeltonArticleView } from '@components/organisms/Skelton/SkeltonArticleView'
import { SkeltonButton } from '@components/organisms/Skelton/SkeltonButton'
import { ArticleFragment } from '@services/graphcms/client'

const PREFIX = 'Content'

const classes = {
  title: `${PREFIX}-title`,
  bookmarkButtonContainer: `${PREFIX}-bookmarkButtonContainer`,
  articleContainer: `${PREFIX}-articleContainer`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.title}`]: {
    fontWeight: 'bold',
  },

  [`& .${classes.bookmarkButtonContainer}`]: {
    minHeight: '2rem',
  },

  [`& .${classes.articleContainer}`]: {
    marginBottom: theme.spacing(2),
    minHeight: '30vh',
  },
}))

const DynamicArticle = dynamic(import('./Article'), { ssr: false })
const DynamicAuthCheckButton = dynamic(import('./AuthCheckButton'), {
  ssr: false,
})
const DynamicContactButton = dynamic(import('./ContactButton'), {
  ssr: false,
})

export type Props = {
  article: ArticleFragment
}

export const Content = (props: Props) => (
  <Root>
    <Container>
      <Typography variant="h5" className={classes.title} data-test="title">
        {props.article.title}
      </Typography>
      <Date article={props.article} fullYear={true} />
      <Tags article={props.article} textType={false} />
      <Container className={classes.bookmarkButtonContainer} disableGutters={true}>
        <React.Suspense fallback={<SkeltonButton />}>
          <DynamicAuthCheckButton article={props.article} />
        </React.Suspense>
      </Container>
      <Container className={classes.articleContainer} disableGutters={true}>
        <React.Suspense fallback={<SkeltonArticleView />}>
          <DynamicArticle article={props.article} />
        </React.Suspense>
        <React.Suspense fallback={<div />}>
          <DynamicContactButton article={props.article} />
        </React.Suspense>
      </Container>
    </Container>
    <Author article={props.article} />
  </Root>
)
